import BaseAPI from "./BaseAPI";
import { useLocation } from 'react-router';
//import queryString from 'query-string';

class AdminUserAPI extends BaseAPI {
    get = async (type) => {
        var promise = await this.init().get("/account/admin/users/");
        return promise;
    };

    getUser = async (userid) => {
        var promise = await this.init().get("/account/admin/user/"+userid);
        return promise;
    };

    saveUser = async (data) => {
        var promise = await this.init().post("/account/admin/user/"+data.key, data);
        return promise;
    };
	
}

export default new AdminUserAPI();